import React from "react";
import * as styles from "./Slideshow.module.scss";
// import Img from "gatsby-image";
import { InternalSlideshowItemProps } from "./Slideshow";
import { ResponsiveSanityImage } from "@silversea-ssc/ui-components-react";

const SlideshowImage: React.FC<
  InternalSlideshowItemProps & {
    className: string;
  }
> = ({
  image,
  imageFit,
  description,
  children,
  isFullscreen,
  className = undefined
}) => {
  return (
    <div className={className}>
      <ResponsiveSanityImage
        image={image}
        draggable={false}
        defaultWidth={900}
        defaultHeight={600}
        fit={
          isFullscreen
            ? "original"
            : imageFit == "contain"
            ? "original"
            : "crop"
        }
      />
      {children}
      {description && (
        <div className={styles.imageCaptionInside}>{description}</div>
      )}
    </div>
  );
};

export default SlideshowImage;
